<template>
  <div class="Phixsoul">
    <div class="banner-wrap">
      <div class="banner-text">
        <p>槃灵软件开发</p>
        <p>PHIXSOUL</p>
      </div>
      <img src="images/phix1.png" alt="">
    </div>
    <div class="service-wrap">
      <main-title title="业务介绍" color="#ec1e24"></main-title>
      <ul class="service-list">
        <li class="service-item" v-for="item in serviceList" :key="item.id">
          <div class="serv-show">
            <p class="serv-title">{{ item.servTitle }}</p>
          </div>
          <div class="serv-hover">
            <p class="serv-title">{{ item.servTitle }}</p>
            <p class="serv-text">{{ item.servText }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mainTitle from '@/components/title'
export default {
  name: 'ghidorah',
  components: {
    mainTitle
  },
  data() {
    return {
      bannerimg: './images/whxq/banner.jpg',
      serviceList: [
        {
          id: 1,
          servTitle: '网站开发',
          servText: '构建响应式、用户友好的网站，提供流畅的浏览体验，支持企业在线展示和互动'
        },
        {
          id: 2,
          servTitle: '应用开发',
          servText: '创建跨平台或特定平台的应用程序，实现高效的功能和卓越的用户体验，满足业务需求'
        },
        {
          id: 3,
          servTitle: '移动开发',
          servText: '专注于iOS和Android平台，开发高性能移动应用，优化触控体验，提升用户参与度'
        },
        {
          id: 4,
          servTitle: 'APP 开发',
          servText: '设计并开发功能丰富的手机应用程序，结合最新技术，确保流畅性和安全性，增强用户粘性'
        },
        {
          id: 5,
          servTitle: '小程序',
          servText: '快速构建轻量级小程序，无缝集成到微信等平台，提供便捷的服务和高效的用户体验'
        },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.Ghidorah {
  margin-top: 80px;
  padding-bottom: 80px;
}

.banner-wrap {
  position: relative;
  width: 100%;
  height: 600px;
  margin-bottom: 50px;
  background-color: #419afe;
  .banner-text {
    position: absolute;
    top: 30%;
    left: 10%;
  }
  p {
    font-size: 68px;
    color: #fff;
    font-weight: bold;
    line-height: 110px;
  }

  img {
    position: absolute;
    right: 10%;
    top: 10%;
    bottom: 0;
    margin: auto;
    width: 500px;
    height: 400px;
  }
}
.service-wrap {
  width: 80%;
  margin: auto;
  margin-bottom: 120px;
}
.service-list {
  display: flex;
  position: relative;
  width: 100%;
  height: 350px;
  margin-top: 45px;
  justify-content: space-between;

  .service-item {
    width: 18%;
    height: 100%;
    background-color: #333;

    &:hover {
      .serv-show {
        display: none;
      }

      .serv-hover {
        display: block;
      }
    }
  }

  .serv-show {
    display: block;
    height: 100%;
    line-height: 350px;
    text-align: center;
    background-image: linear-gradient(to bottom right, #8abdf6, #2382ee);

    .serv-icon {
      display: inline-block;
      width: 42px;
      height: 48px;
      margin-bottom: 22px;
      background-size: cover;
    }

    .serv-title {
      color: #fff;
      font-weight: bold;
      font-size: 32px;
    }
  }

  .serv-hover {
    display: none;
    width: 100%;
    height: 100%;
    background-color: #f9931f;

    .serv-title {
      position: relative;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-weight: 500;
      color: #fff;
      font-size: 24px;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 10%;
        right: 10%;
        border: 1px dashed #fff;
        opacity: .4;
      }
    }

    .serv-text {
      padding: 18px 30px;
      font-size: 18px;
      color: #fff;
      text-align: justify;
    }
  }
}
</style>